console.clear();
console.log("counter");
function Counter(countTo, targetElement) {
  const me = this;
   me.targetElement = targetElement;
  me.countTo = me.targetElement.parentNode.querySelector(".bannersnippet .els-cup-w-val")? parseInt(me.targetElement.parentNode.querySelector(".bannersnippet .els-cup-w-val").textContent):0;
  me.count = 0;
 
  me.updateCounTo = function (countTo) {
    me.countTo = countTo > me.countTo ? countTo : me.countTo;
    updateClock();
  };
  function checkCounterUpdate(){
    me.countTo = me.targetElement.parentNode.querySelector(".bannersnippet .els-cup-w-val")? parseInt(me.targetElement.parentNode.querySelector(".bannersnippet .els-cup-w-val").textContent):me.countTo;
  }
  function CountdownTracker(label, value) {
    var el = document.createElement("span");

    el.className = "flip-clock__piece";
    el.innerHTML =
      '<b class="flip-clock__card card"><b class="card__top"></b><b class="card__bottom"></b><b class="card__back"><b class="card__bottom"></b></b></b>';

    this.el = el;
this.currentValue = ""+value;
    var top = el.querySelector(".card__top"),
      bottom = el.querySelector(".card__bottom"),
      back = el.querySelector(".card__back"),
      backBottom = el.querySelector(".card__back .card__bottom");

    this.update = function (val) {
   
      if (val !== this.currentValue) {
        if (this.currentValue < me.countTo) {
          back.setAttribute("data-value", this.currentValue);
          bottom.setAttribute("data-value", this.currentValue);
        }
        this.currentValue = val;
        top.innerText = this.currentValue;
        backBottom.setAttribute("data-value", this.currentValue);

        this.el.classList.remove("flip");
        void this.el.offsetWidth;
        this.el.classList.add("flip");
      }
    };

    this.update(value);
  }

  function getValue() {
    if (me.countTo < 0) {
      me.countTo = 0;
    }
    return {
      ve3: getPositionNumber(me.count, 3),
      ve2: getPositionNumber(me.count, 2),
      ve1: getPositionNumber(me.count, 1),
      ve0: getPositionNumber(me.count, 0),
    };
  }
  function add1ToValue(){
    var e3=getPositionNumber(me.count, 3)!=getPositionNumber(me.countTo, 3)?getPositionNumber(getPositionNumber(me.count, 3)+1,0):getPositionNumber(me.count, 3);
    var e2=getPositionNumber(me.count, 2)!=getPositionNumber(me.countTo, 2)?getPositionNumber(getPositionNumber(me.count, 2)+1,0):getPositionNumber(me.count, 2);
    var e1=getPositionNumber(me.count, 1)!=getPositionNumber(me.countTo, 1)?getPositionNumber(getPositionNumber(me.count, 1)+1,0):getPositionNumber(me.count, 1);
    var e0=getPositionNumber(me.count, 0)!=getPositionNumber(me.countTo, 0)?getPositionNumber(getPositionNumber(me.count, 0)+1,0):getPositionNumber(me.count, 0);
    return (e3*1000)+(e2*100)+(e1*10)+e0;      
  }
  function Clock(countto, callback) {
    callback =
      callback ||
      function () {
        me.count=add1ToValue();
      };

    var updateFn = getValue;

    this.el = document.createElement("div");
    this.el.className = "flip-clock";

    var trackers = {},
      t = updateFn(),
      key,
      timeinterval;

    for (key in t) {
      trackers[key] = new CountdownTracker(key, t[key]);
      this.el.appendChild(trackers[key].el);
    }

    var i = 0;
    function updateClock() {

      // throttle so it's not constantly updating the time.
      if (i++ % 10) {
        i = 0;
        return;
      }

      var t = updateFn();
      if (me.count > me.countTo) {
        cancelAnimationFrame(me.timeinterval);
        for (key in trackers) {
          trackers[key].update(t[key]);
        }

        return;
      }

      for (key in trackers) {
        trackers[key].update(t[key]);
      }
      callback();
    }
    me.count=add1ToValue();
      me.clockinterval =setInterval(()=>{me.timeinterval=requestAnimationFrame(updateClock)}, 100);
    //setTimeout(updateClock, 500);
  }
const config = { attributes: false, childList: true, subtree: false };
    me.updateCounterCheck=(mutationsList, observer)=> {
       for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {

        }
     }  
  }

  var deadline = 300;

  var clock = new Clock();
  me.targetElement.appendChild(clock.el);

  function getPositionNumber(val, pos) {
    return Math.floor(val / Math.pow(10, pos)) % 10;
  }
  me.checkCounterInterval=setInterval(checkCounterUpdate, 1000);
}

const bfcounter=new Counter(0,document.querySelector(".counterbody"));
